import type { ComponentType, SVGProps } from "react";
import { cn } from "@shared/lib/utils";

export interface DirIconProps extends SVGProps<SVGSVGElement> {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export function DirIcon({ icon: Icon, className, ...props }: DirIconProps) {
  return <Icon className={cn("rtl:scale-x-[-1]", className)} {...props} />;
}
